'use client';

import React, { FC, JSX } from 'react';
import Communication from '@/components/Communication/Communication';
import { EditablePage } from '@magnolia/react-editor';
import { config as mgnlConfig, PageProps } from '@/Util/magnolia';
import ContextProvider from '@/components/contextProviders/ContextProviders';

const MagnoliaPage: FC<{
  props: PageProps;
  isProduction: boolean;
  isLocal?: string;
}> = ({ props, isProduction, isLocal }): JSX.Element => {
  const { locale, page, magnoliaContext, templateAnnotations } = props;

  return (
    <ContextProvider
      pageProps={JSON.parse(JSON.stringify(props))}
      isProduction={isProduction}
      locale={locale}
      isLocal={isLocal}
    >
      <Communication>
        {page && (
          <EditablePage
            content={{ ...page, pageProps: props }}
            config={mgnlConfig}
            magnoliaContext={magnoliaContext}
            templateAnnotations={templateAnnotations}
          />
        )}
      </Communication>
    </ContextProvider>
  );
};

export default MagnoliaPage;
